const UNIT_LIBRARY = {
  '고대': [
    {
      id: 'raft',
      name: '뗏목',
      rarity: 'common',
      baseDamage: 6,
      fireRate: 0.9,
      range: 140,
      projectileSpeed: 220,
      upgDamage: 2,
      weaponType: 'bow',
    },
    {
      id: 'ferry',
      name: '나룻배',
      rarity: 'common',
      baseDamage: 5,
      fireRate: 1.4,
      range: 130,
      projectileSpeed: 240,
      upgDamage: 1.8,
      weaponType: 'bow',
    },
    {
      id: 'sailboat',
      name: '돛단배',
      rarity: 'rare',
      baseDamage: 9,
      fireRate: 1.1,
      range: 180,
      projectileSpeed: 260,
      upgDamage: 2.6,
      weaponType: 'bow',
    },
    {
      id: 'war_rowboat',
      name: '전투 노선',
      rarity: 'rare',
      baseDamage: 8,
      fireRate: 1.3,
      range: 160,
      projectileSpeed: 250,
      upgDamage: 2.4,
      weaponType: 'bow',
    },
    {
      id: 'bowship',
      name: '활시위선',
      rarity: 'unique',
      baseDamage: 14,
      fireRate: 0.9,
      range: 200,
      projectileSpeed: 320,
      upgDamage: 3.2,
      weaponType: 'bow',
    },
    {
      id: 'ballista_raft',
      name: '발리스타 뗏목',
      rarity: 'unique',
      baseDamage: 16,
      fireRate: 0.8,
      range: 200,
      projectileSpeed: 300,
      upgDamage: 3.0,
      weaponType: 'ballista',
    },
    {
      id: 'longbowship',
      name: '장궁선',
      rarity: 'legendary',
      baseDamage: 24,
      fireRate: 0.8,
      range: 230,
      projectileSpeed: 340,
      upgDamage: 4.1,
      weaponType: 'bow',
    },
    {
      id: 'royal_courier',
      name: '왕실 호위선',
      rarity: 'legendary',
      baseDamage: 22,
      fireRate: 1.0,
      range: 220,
      projectileSpeed: 320,
      upgDamage: 3.8,
      weaponType: 'ballista',
    },
  ],
  '삼국': [
    {
      id: 'coastal_combat',
      name: '연안 전투선',
      rarity: 'common',
      baseDamage: 8,
      fireRate: 1.0,
      range: 150,
      projectileSpeed: 240,
      upgDamage: 2.2,
      weaponType: 'ballista',
    },
    {
      id: 'oared_combatant',
      name: '노선(삼국)',
      rarity: 'common',
      baseDamage: 7,
      fireRate: 1.2,
      range: 150,
      projectileSpeed: 240,
      upgDamage: 2.0,
      weaponType: 'ballista',
    },
    {
      id: 'arrow_tower_ship',
      name: '화살탑선',
      rarity: 'rare',
      baseDamage: 10,
      fireRate: 1.4,
      range: 170,
      projectileSpeed: 260,
      upgDamage: 2.8,
      weaponType: 'ballista',
    },
    {
      id: 'repeating_crossbow_ship',
      name: '연노선',
      rarity: 'rare',
      baseDamage: 11,
      fireRate: 1.5,
      range: 160,
      projectileSpeed: 260,
      upgDamage: 2.6,
      weaponType: 'ballista',
    },
    {
      id: 'ram_ship',
      name: '충각선',
      rarity: 'unique',
      baseDamage: 20,
      fireRate: 0.8,
      range: 130,
      projectileSpeed: 280,
      upgDamage: 3.4,
      weaponType: 'ballista',
    },
    {
      id: 'tower_ship',
      name: '누선',
      rarity: 'unique',
      baseDamage: 22,
      fireRate: 0.9,
      range: 200,
      projectileSpeed: 300,
      upgDamage: 3.2,
      weaponType: 'ballista',
    },
    {
      id: 'flagship_three_kingdoms',
      name: '기함',
      rarity: 'legendary',
      baseDamage: 28,
      fireRate: 0.9,
      range: 220,
      projectileSpeed: 320,
      upgDamage: 4.5,
      weaponType: 'ballista',
    },
    {
      id: 'fireship_three_kingdoms',
      name: '화공선',
      rarity: 'legendary',
      baseDamage: 30,
      fireRate: 0.8,
      range: 200,
      projectileSpeed: 300,
      upgDamage: 4.2,
      weaponType: 'cannon',
    },
  ],
  '고려': [
    {
      id: 'reinforced_wood',
      name: '강화 목선',
      rarity: 'common',
      baseDamage: 9,
      fireRate: 1.0,
      range: 160,
      projectileSpeed: 250,
      upgDamage: 2.4,
      weaponType: 'cannon',
    },
    {
      id: 'goryeo_row',
      name: '노선(고려)',
      rarity: 'common',
      baseDamage: 8,
      fireRate: 1.2,
      range: 150,
      projectileSpeed: 240,
      upgDamage: 2.2,
      weaponType: 'ballista',
    },
    {
      id: 'early_cannon',
      name: '화포 초기형',
      rarity: 'rare',
      baseDamage: 15,
      fireRate: 0.9,
      range: 200,
      projectileSpeed: 300,
      upgDamage: 3,
      weaponType: 'cannon',
    },
    {
      id: 'improved_goryeo_cannon',
      name: '화포 개량형',
      rarity: 'rare',
      baseDamage: 16,
      fireRate: 1.0,
      range: 210,
      projectileSpeed: 310,
      upgDamage: 3.2,
      weaponType: 'cannon',
    },
    {
      id: 'heavy_cannon',
      name: '개량 화포선',
      rarity: 'unique',
      baseDamage: 24,
      fireRate: 0.8,
      range: 210,
      projectileSpeed: 320,
      upgDamage: 3.8,
      weaponType: 'cannon',
    },
    {
      id: 'armored_gunboat_goryeo',
      name: '중무장 포선',
      rarity: 'unique',
      baseDamage: 26,
      fireRate: 0.85,
      range: 220,
      projectileSpeed: 320,
      upgDamage: 3.8,
      weaponType: 'cannon',
    },
    {
      id: 'shield_ship',
      name: '방패선',
      rarity: 'legendary',
      baseDamage: 22,
      fireRate: 0.95,
      range: 200,
      projectileSpeed: 280,
      upgDamage: 3.6,
      weaponType: 'cannon',
    },
    {
      id: 'fire_attack_goryeo',
      name: '화공 돌격선',
      rarity: 'legendary',
      baseDamage: 26,
      fireRate: 1.0,
      range: 190,
      projectileSpeed: 300,
      upgDamage: 3.6,
      weaponType: 'cannon',
    },
    {
      id: 'jinpo_fire_ship',
      name: '진포 화포선',
      rarity: 'mythic',
      baseDamage: 34,
      fireRate: 0.92,
      range: 240,
      projectileSpeed: 340,
      upgDamage: 4.8,
      weaponType: 'cannon',
    },
    {
      id: 'goryeo_grand_bombard',
      name: '대화포선',
      rarity: 'primordial',
      baseDamage: 40,
      fireRate: 0.88,
      range: 260,
      projectileSpeed: 360,
      upgDamage: 5.6,
      weaponType: 'cannon',
    },
  ],
  '조선 전기': [
    {
      id: 'sugun_training_boat',
      name: '수군 훈련선',
      rarity: 'common',
      baseDamage: 11,
      fireRate: 1.35,
      range: 170,
      projectileSpeed: 260,
      upgDamage: 2.4,
      weaponType: 'arquebus',
    },
    {
      id: 'hyup_ship',
      name: '협선',
      rarity: 'rare',
      baseDamage: 12,
      fireRate: 1.4,
      range: 170,
      projectileSpeed: 280,
      upgDamage: 2.6,
      weaponType: 'arquebus',
    },
    {
      id: 'seonjang_ship',
      name: '선장선',
      rarity: 'rare',
      baseDamage: 14,
      fireRate: 1.3,
      range: 180,
      projectileSpeed: 280,
      upgDamage: 2.6,
      weaponType: 'arquebus',
    },
    {
      id: 'large_oar',
      name: '대형 노선',
      rarity: 'unique',
      baseDamage: 22,
      fireRate: 1.0,
      range: 200,
      projectileSpeed: 300,
      upgDamage: 3.5,
      weaponType: 'arquebus',
    },
    {
      id: 'early_panok_variant',
      name: '중형 전선(초기)',
      rarity: 'unique',
      baseDamage: 24,
      fireRate: 1.0,
      range: 210,
      projectileSpeed: 300,
      upgDamage: 3.4,
      weaponType: 'cannon',
    },
    {
      id: 'panokseon',
      name: '판옥선',
      rarity: 'legendary',
      baseDamage: 32,
      fireRate: 0.9,
      range: 220,
      projectileSpeed: 340,
      upgDamage: 4.6,
      weaponType: 'cannon',
    },
    {
      id: 'great_panokseon',
      name: '대형 판옥선',
      rarity: 'legendary',
      baseDamage: 36,
      fireRate: 0.85,
      range: 230,
      projectileSpeed: 340,
      upgDamage: 4.8,
      weaponType: 'cannon',
    },
  ],
  '조선 후기': [
    {
      id: 'byeongseon',
      name: '병선',
      rarity: 'rare',
      baseDamage: 24,
      fireRate: 1.15,
      range: 210,
      projectileSpeed: 340,
      upgDamage: 3.4,
      weaponType: 'cannon',
    },
    {
      id: 'improved_cannon',
      name: '대포선 개량형',
      rarity: 'unique',
      baseDamage: 28,
      fireRate: 0.9,
      range: 230,
      projectileSpeed: 340,
      upgDamage: 4.2,
      weaponType: 'cannon',
    },
    {
      id: 'fast_raider',
      name: '쾌속 돌격선',
      rarity: 'unique',
      baseDamage: 26,
      fireRate: 1.2,
      range: 210,
      projectileSpeed: 340,
      upgDamage: 4.0,
      weaponType: 'rifle',
    },
    {
      id: 'raider',
      name: '기동 돌격선',
      rarity: 'legendary',
      baseDamage: 36,
      fireRate: 1.1,
      range: 200,
      projectileSpeed: 360,
      upgDamage: 5,
      weaponType: 'rifle',
    },
    {
      id: 'turtle_ship',
      name: '거북선',
      rarity: 'mythic',
      baseDamage: 50,
      fireRate: 1.0,
      range: 240,
      projectileSpeed: 380,
      upgDamage: 6.2,
      weaponType: 'cannon',
    },
    {
      id: 'turtle_ship_variant',
      name: '거북선(개량)',
      rarity: 'mythic',
      baseDamage: 54,
      fireRate: 1.0,
      range: 250,
      projectileSpeed: 380,
      upgDamage: 6.6,
      weaponType: 'cannon',
    },
    {
      id: 'hwacha_ship',
      name: '화차선',
      rarity: 'legendary',
      baseDamage: 38,
      fireRate: 1.2,
      range: 220,
      projectileSpeed: 360,
      upgDamage: 5.0,
      weaponType: 'missile',
    },
    {
      id: 'jeongjo_turtle_ship',
      name: '거북선(정조 재현)',
      rarity: 'primordial',
      baseDamage: 62,
      fireRate: 1.0,
      range: 260,
      projectileSpeed: 400,
      upgDamage: 7.4,
      weaponType: 'cannon',
    },
  ],
  '개화기/대한제국': [
    {
      id: 'unyango',
      name: '운양호',
      rarity: 'common',
      baseDamage: 16,
      fireRate: 1.2,
      range: 200,
      projectileSpeed: 300,
      upgDamage: 2.6,
      weaponType: 'rifle',
    },
    {
      id: 'steam_trader',
      name: '증기 통상선',
      rarity: 'rare',
      baseDamage: 18,
      fireRate: 1.2,
      range: 210,
      projectileSpeed: 320,
      upgDamage: 3.2,
      weaponType: 'rifle',
    },
    {
      id: 'torpedo_boat',
      name: '어뢰정',
      rarity: 'unique',
      baseDamage: 42,
      fireRate: 0.8,
      range: 200,
      projectileSpeed: 400,
      upgDamage: 5.6,
      weaponType: 'missile',
    },
    {
      id: 'armored_cruiser',
      name: '장갑함',
      rarity: 'mythic',
      baseDamage: 52,
      fireRate: 0.9,
      range: 260,
      projectileSpeed: 420,
      upgDamage: 6.4,
      weaponType: 'naval_gun',
    },
    {
      id: 'protected_cruiser',
      name: '경장갑함',
      rarity: 'legendary',
      baseDamage: 50,
      fireRate: 0.95,
      range: 260,
      projectileSpeed: 420,
      upgDamage: 6.2,
      weaponType: 'naval_gun',
    },
    {
      id: 'yangmu',
      name: '양무함(훈련함)',
      rarity: 'rare',
      baseDamage: 22,
      fireRate: 1.0,
      range: 230,
      projectileSpeed: 360,
      upgDamage: 3.4,
      weaponType: 'naval_gun',
    },
    {
      id: 'kwangmu',
      name: '광무함(훈련함)',
      rarity: 'unique',
      baseDamage: 30,
      fireRate: 0.95,
      range: 240,
      projectileSpeed: 380,
      upgDamage: 4.2,
      weaponType: 'naval_gun',
    },
    {
      id: 'gwangjeho',
      name: '광제호',
      rarity: 'primordial',
      baseDamage: 58,
      fireRate: 1.0,
      range: 280,
      projectileSpeed: 440,
      upgDamage: 6.8,
      weaponType: 'naval_gun',
    },
  ],
  '현대 초창기': [
    {
      id: 'munsan_lsm',
      name: '문산함(LSM-653)',
      rarity: 'common',
      baseDamage: 18,
      fireRate: 1.05,
      range: 200,
      projectileSpeed: 320,
      upgDamage: 2.8,
      weaponType: 'rifle',
    },
    {
      id: 'landing_craft',
      name: '상륙정',
      rarity: 'rare',
      baseDamage: 20,
      fireRate: 1.1,
      range: 200,
      projectileSpeed: 320,
      upgDamage: 3.4,
      weaponType: 'rifle',
    },
    {
      id: 'patrol_boat',
      name: '초계함',
      rarity: 'unique',
      baseDamage: 34,
      fireRate: 1.3,
      range: 230,
      projectileSpeed: 360,
      upgDamage: 4.8,
      weaponType: 'naval_gun',
    },
    {
      id: 'fast_attack',
      name: '고속정',
      rarity: 'legendary',
      baseDamage: 40,
      fireRate: 1.5,
      range: 210,
      projectileSpeed: 420,
      upgDamage: 5.2,
      weaponType: 'missile',
    },
    {
      id: 'coastal_patrol_unique',
      name: '연안 경비정',
      rarity: 'unique',
      baseDamage: 32,
      fireRate: 1.3,
      range: 220,
      projectileSpeed: 360,
      upgDamage: 4.4,
      weaponType: 'naval_gun',
    },
    {
      id: 'loan_destroyer',
      name: '공여 구축함',
      rarity: 'legendary',
      baseDamage: 46,
      fireRate: 1.0,
      range: 260,
      projectileSpeed: 420,
      upgDamage: 5.6,
      weaponType: 'naval_gun',
    },
    {
      id: 'pc701_baekdusan',
      name: '백두산함(PC-701)',
      rarity: 'rare',
      baseDamage: 22,
      fireRate: 1.3,
      range: 220,
      projectileSpeed: 360,
      upgDamage: 3.2,
      weaponType: 'naval_gun',
    },
    {
      id: 'yms_minesweeper',
      name: 'YMS 소해정',
      rarity: 'rare',
      baseDamage: 16,
      fireRate: 1.2,
      range: 200,
      projectileSpeed: 320,
      upgDamage: 2.8,
      weaponType: 'naval_gun',
    },
    {
      id: 'donghae_pc',
      name: '동해급 초계정',
      rarity: 'rare',
      baseDamage: 24,
      fireRate: 1.4,
      range: 220,
      projectileSpeed: 360,
      upgDamage: 3.4,
      weaponType: 'naval_gun',
    },
  ],
  '현대': [
    {
      id: 'pkm',
      name: '참수리급 고속정',
      rarity: 'rare',
      baseDamage: 26,
      fireRate: 1.6,
      range: 220,
      projectileSpeed: 400,
      upgDamage: 3.8,
      weaponType: 'naval_gun',
    },
    {
      id: 'frigate',
      name: '호위함',
      rarity: 'unique',
      baseDamage: 44,
      fireRate: 1.1,
      range: 260,
      projectileSpeed: 440,
      upgDamage: 5.4,
      weaponType: 'naval_gun',
    },
    {
      id: 'kdx2',
      name: '충무공 이순신급 구축함',
      rarity: 'legendary',
      baseDamage: 58,
      fireRate: 1.0,
      range: 300,
      projectileSpeed: 460,
      upgDamage: 6.8,
      weaponType: 'naval_gun',
    },
    {
      id: 'kdx3',
      name: '세종대왕급 이지스 구축함',
      rarity: 'mythic',
      baseDamage: 72,
      fireRate: 1.1,
      range: 320,
      projectileSpeed: 500,
      upgDamage: 7.6,
      weaponType: 'missile',
    },
    {
      id: 'pkx_a',
      name: '윤영하급 고속정(PKX-A)',
      rarity: 'legendary',
      baseDamage: 42,
      fireRate: 1.6,
      range: 230,
      projectileSpeed: 440,
      upgDamage: 5.6,
      weaponType: 'missile',
      size: 2,
    },
    {
      id: 'pkx_b',
      name: '검독수리급 고속정(PKX-B)',
      rarity: 'unique',
      baseDamage: 40,
      fireRate: 1.6,
      range: 230,
      projectileSpeed: 430,
      upgDamage: 5.0,
      weaponType: 'missile',
      size: 2,
    },
    {
      id: 'pohang_pcc',
      name: '포항급 초계함(PCC)',
      rarity: 'unique',
      baseDamage: 36,
      fireRate: 1.2,
      range: 250,
      projectileSpeed: 420,
      upgDamage: 4.6,
      weaponType: 'naval_gun',
      size: 3,
    },
    {
      id: 'ulsan_ff',
      name: '울산급 호위함(FF)',
      rarity: 'unique',
      baseDamage: 38,
      fireRate: 1.2,
      range: 260,
      projectileSpeed: 430,
      upgDamage: 5.0,
      weaponType: 'naval_gun',
      size: 3,
    },
    {
      id: 'incheon_ffg',
      name: '인천급 호위함(FFG)',
      rarity: 'unique',
      baseDamage: 46,
      fireRate: 1.1,
      range: 270,
      projectileSpeed: 450,
      upgDamage: 5.6,
      weaponType: 'naval_gun',
      size: 4,
    },
    {
      id: 'daegu_ffg',
      name: '대구급 호위함(FFG Batch-II)',
      rarity: 'legendary',
      baseDamage: 50,
      fireRate: 1.1,
      range: 280,
      projectileSpeed: 460,
      upgDamage: 6.0,
      weaponType: 'naval_gun',
      size: 4,
    },
    {
      id: 'kdx1',
      name: '광개토대왕급 구축함(KDX-I)',
      rarity: 'legendary',
      baseDamage: 52,
      fireRate: 1.05,
      range: 300,
      projectileSpeed: 460,
      upgDamage: 6.4,
      weaponType: 'naval_gun',
      size: 6,
    },
    {
      id: 'dokdo_lph',
      name: '독도급 대형수송함(LPH)',
      rarity: 'legendary',
      baseDamage: 30,
      fireRate: 1.0,
      range: 260,
      projectileSpeed: 420,
      upgDamage: 4.0,
      weaponType: 'naval_gun',
      size: 8,
    },
    {
      id: 'cheonwangbong_lst',
      name: '천왕봉급 상륙함(LST-II)',
      rarity: 'unique',
      baseDamage: 28,
      fireRate: 1.0,
      range: 240,
      projectileSpeed: 400,
      upgDamage: 3.8,
      weaponType: 'naval_gun',
      size: 6,
    },
    {
      id: 'yangyang_mhc',
      name: '양양급 기뢰탐색함(MHC)',
      rarity: 'rare',
      baseDamage: 18,
      fireRate: 1.1,
      range: 220,
      projectileSpeed: 360,
      upgDamage: 3.0,
      weaponType: 'naval_gun',
      size: 2,
    },
    {
      id: 'wonsan_mls',
      name: '원산급 기뢰부설함(MLS)',
      rarity: 'rare',
      baseDamage: 20,
      fireRate: 1.0,
      range: 230,
      projectileSpeed: 360,
      upgDamage: 3.2,
      weaponType: 'naval_gun',
      size: 3,
    },
    {
      id: 'jangbogo_kss1',
      name: '장보고급 잠수함(KSS-I)',
      rarity: 'unique',
      baseDamage: 48,
      fireRate: 0.9,
      range: 260,
      projectileSpeed: 460,
      upgDamage: 5.2,
      weaponType: 'missile',
      size: 3,
    },
    {
      id: 'sonwoneil_kss2',
      name: '손원일급 잠수함(KSS-II)',
      rarity: 'legendary',
      baseDamage: 60,
      fireRate: 0.85,
      range: 280,
      projectileSpeed: 480,
      upgDamage: 6.8,
      weaponType: 'missile',
      size: 4,
    },
    {
      id: 'dosan_ahn_changho_kss3',
      name: '도산안창호급 잠수함(KSS-III)',
      rarity: 'mythic',
      baseDamage: 80,
      fireRate: 0.8,
      range: 300,
      projectileSpeed: 500,
      upgDamage: 7.8,
      weaponType: 'missile',
      size: 5,
    },
  ],
  '근미래': [
    {
      id: 'kddx',
      name: 'KDDX',
      rarity: 'unique',
      baseDamage: 52,
      fireRate: 1.3,
      range: 300,
      projectileSpeed: 500,
      upgDamage: 6.2,
      weaponType: 'naval_gun',
    },
    {
      id: 'ffx_iii',
      name: 'FFX-III',
      rarity: 'unique',
      baseDamage: 56,
      fireRate: 1.2,
      range: 310,
      projectileSpeed: 500,
      upgDamage: 6.4,
      weaponType: 'naval_gun',
    },
    {
      id: 'jangbogo3',
      name: '장보고-III 개량',
      rarity: 'legendary',
      baseDamage: 90,
      fireRate: 0.7,
      range: 280,
      projectileSpeed: 520,
      upgDamage: 8,
      weaponType: 'missile',
    },
    {
      id: 'cvx',
      name: '경항모(CVX)',
      rarity: 'legendary',
      baseDamage: 70,
      fireRate: 1.0,
      range: 300,
      projectileSpeed: 520,
      upgDamage: 7.2,
      weaponType: 'missile',
    },
    {
      id: 'future_aegis',
      name: '차세대 이지스',
      rarity: 'primordial',
      baseDamage: 120,
      fireRate: 1.2,
      range: 360,
      projectileSpeed: 560,
      upgDamage: 10,
      weaponType: 'missile',
    },
    {
      id: 'stealth_ddx',
      name: '차세대 스텔스 구축함',
      rarity: 'primordial',
      baseDamage: 128,
      fireRate: 1.2,
      range: 380,
      projectileSpeed: 580,
      upgDamage: 10.5,
      weaponType: 'missile',
    },
  ],
};

export { UNIT_LIBRARY };
